export enum ValidationType {
  DEFAULTS_TO_EMPTY = 0,
  IS_REQUIRED = 1,
  VALUES_MATCH = 2,
  STRENGTH_MET = 3,
}

export enum ValidationMessageType {
  DEFAULTS_TO_EMPTY = '',
  IS_REQUIRED = 'is required',
  STRENGTH_NOT_MET = 'Your password must be at least 10 characters long.',
  VALUES_MUST_MATCH = 'Password match is required',
  WEAK_PASSWORD = 'Weak passwords are not allowed',
}
